import { render, staticRenderFns } from "./ColumnSection.vue?vue&type=template&id=35a4ada2&scoped=true&"
import script from "./ColumnSection.vue?vue&type=script&lang=js&"
export * from "./ColumnSection.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSection.vue?vue&type=style&index=0&id=35a4ada2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4ada2",
  null
  
)

export default component.exports